// Generated by purs version 0.14.3
"use strict";
var Control_Applicative = require("../Control.Applicative/index.js");
var Control_Bind = require("../Control.Bind/index.js");
var Control_Coroutine = require("../Control.Coroutine/index.js");
var Control_Coroutine_Transducer = require("../Control.Coroutine.Transducer/index.js");
var Control_Monad_Fork_Class = require("../Control.Monad.Fork.Class/index.js");
var Control_Monad_Free_Trans = require("../Control.Monad.Free.Trans/index.js");
var Control_Monad_Reader_Trans = require("../Control.Monad.Reader.Trans/index.js");
var Control_Monad_Trans_Class = require("../Control.Monad.Trans.Class/index.js");
var Data_Array = require("../Data.Array/index.js");
var Data_Either = require("../Data.Either/index.js");
var Data_Eq = require("../Data.Eq/index.js");
var Data_Foldable = require("../Data.Foldable/index.js");
var Data_Function = require("../Data.Function/index.js");
var Data_Functor = require("../Data.Functor/index.js");
var Data_Functor_Coproduct = require("../Data.Functor.Coproduct/index.js");
var Data_Functor_Tagged = require("../Data.Functor.Tagged/index.js");
var Data_Lens_Getter = require("../Data.Lens.Getter/index.js");
var Data_Lens_Internal_Forget = require("../Data.Lens.Internal.Forget/index.js");
var Data_Lens_Setter = require("../Data.Lens.Setter/index.js");
var Data_Maybe = require("../Data.Maybe/index.js");
var Data_Newtype = require("../Data.Newtype/index.js");
var Data_Ord = require("../Data.Ord/index.js");
var Data_Profunctor_Strong = require("../Data.Profunctor.Strong/index.js");
var Data_Ring = require("../Data.Ring/index.js");
var Data_Semigroup = require("../Data.Semigroup/index.js");
var Data_Semiring = require("../Data.Semiring/index.js");
var Data_Tuple = require("../Data.Tuple/index.js");
var Data_Unit = require("../Data.Unit/index.js");
var Data_Variant = require("../Data.Variant/index.js");
var Effect_Aff = require("../Effect.Aff/index.js");
var Effect_Aff_Class = require("../Effect.Aff.Class/index.js");
var Heterogeneous_Folding = require("../Heterogeneous.Folding/index.js");
var Heterogeneous_Mapping = require("../Heterogeneous.Mapping/index.js");
var Network_Ethereum_Core_BigNumber = require("../Network.Ethereum.Core.BigNumber/index.js");
var Network_Ethereum_Web3_Api = require("../Network.Ethereum.Web3.Api/index.js");
var Network_Ethereum_Web3_Solidity_Event = require("../Network.Ethereum.Web3.Solidity.Event/index.js");
var Network_Ethereum_Web3_Types_Types = require("../Network.Ethereum.Web3.Types.Types/index.js");
var Record = require("../Record/index.js");
var Type_Proxy = require("../Type.Proxy/index.js");
var QueryAllLogs = (function () {
    function QueryAllLogs() {

    };
    QueryAllLogs.value = new QueryAllLogs();
    return QueryAllLogs;
})();
var OpenMultiFilter = (function () {
    function OpenMultiFilter() {

    };
    OpenMultiFilter.value = new OpenMultiFilter();
    return OpenMultiFilter;
})();
var MultiFilterStreamState = (function () {
    function MultiFilterStreamState(value0) {
        this.value0 = value0;
    };
    MultiFilterStreamState.create = function (value0) {
        return new MultiFilterStreamState(value0);
    };
    return MultiFilterStreamState;
})();
var MultiFilterMinToBlock = (function () {
    function MultiFilterMinToBlock() {

    };
    MultiFilterMinToBlock.value = new MultiFilterMinToBlock();
    return MultiFilterMinToBlock;
})();
var MultiFilterMinFromBlock = (function () {
    function MultiFilterMinFromBlock() {

    };
    MultiFilterMinFromBlock.value = new MultiFilterMinFromBlock();
    return MultiFilterMinFromBlock;
})();
var ModifyFilter = (function () {
    function ModifyFilter(value0) {
        this.value0 = value0;
    };
    ModifyFilter.create = function (value0) {
        return new ModifyFilter(value0);
    };
    return ModifyFilter;
})();
var FilterChange = function (x) {
    return x;
};
var CloseMultiFilter = (function () {
    function CloseMultiFilter() {

    };
    CloseMultiFilter.value = new CloseMultiFilter();
    return CloseMultiFilter;
})();
var CheckMultiFilter = (function () {
    function CheckMultiFilter() {

    };
    CheckMultiFilter.value = new CheckMultiFilter();
    return CheckMultiFilter;
})();
var stagger = function (dictMonad) {
    return function (dictMonadRec) {
        return function (dictParallel) {
            return function (osT) {
                var trickle = Control_Coroutine_Transducer.awaitForever(dictMonad)(function (os) {
                    return Data_Foldable.for_(Control_Monad_Free_Trans.applicativeFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(dictMonad))(Data_Foldable.foldableArray)(os)(Control_Coroutine_Transducer.yieldT(dictMonad));
                });
                return Data_Functor.map(Control_Monad_Free_Trans.functorFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(((dictMonad.Bind1()).Apply0()).Functor0()))(Data_Tuple.fst)(Control_Coroutine_Transducer.fuse(dictMonadRec)(dictParallel)(osT)(trickle));
            };
        };
    };
};
var processChange = function (dictMonad) {
    return function (dictRowToList) {
        return function (dictVariantMatchCases) {
            return function (dictUnion) {
                return function (handlerRec) {
                    return function (v) {
                        return Control_Bind.bind(dictMonad.Bind1())(Control_Monad_Reader_Trans.runReaderT(Data_Variant.match()()()(handlerRec)(v.event))(v.rawChange))(function (action) {
                            return Control_Applicative.pure(dictMonad.Applicative0())({
                                logIndex: v.rawChange.logIndex,
                                blockHash: v.rawChange.blockHash,
                                blockNumber: v.rawChange.blockNumber,
                                action: action
                            });
                        });
                    };
                };
            };
        };
    };
};
var openMultiFilterFold = function (dictLacks) {
    return function (dictIsSymbol) {
        return function (dictUnion) {
            return function (dictCons) {
                return new Heterogeneous_Folding.FoldingWithIndex(function (v) {
                    return function (v1) {
                        return function (acc) {
                            return function (filter) {
                                return Control_Bind.bind(Network_Ethereum_Web3_Types_Types.bindWeb3)(Network_Ethereum_Web3_Api.eth_newFilter(filter))(function (filterId) {
                                    return Data_Functor.map(Network_Ethereum_Web3_Types_Types.functorWeb3)(Record.insert(dictIsSymbol)()()(v1)(Data_Functor_Tagged.tagged(filterId)))(acc);
                                });
                            };
                        };
                    };
                });
            };
        };
    };
};
var openMultiFilter = function (dictFoldlRecord) {
    return function (dictRowToList) {
        return Heterogeneous_Folding.hfoldlWithIndex(Heterogeneous_Folding.hfoldlRecordWithIndex()(dictFoldlRecord))(OpenMultiFilter.value)(Control_Applicative.pure(Network_Ethereum_Web3_Types_Types.applicativeWeb3)({}));
    };
};
var modifyFilter = new Heterogeneous_Mapping.Mapping(function (v) {
    return function (filter) {
        return v.value0(filter);
    };
});
var mkFilterChanges = function (dictDecodeEvent) {
    return function (dictCons) {
        return function (dictIsSymbol) {
            return function (sp) {
                return function (v) {
                    return function (cs) {
                        var pairChange = function (rawChange) {
                            return Control_Bind.bind(Data_Maybe.bindMaybe)(Network_Ethereum_Web3_Solidity_Event.decodeEvent(dictDecodeEvent)(rawChange))(function (v1) {
                                return Control_Applicative.pure(Data_Maybe.applicativeMaybe)({
                                    rawChange: rawChange,
                                    event: Data_Variant.inj()(dictIsSymbol)(sp)(v1)
                                });
                            });
                        };
                        return Data_Array.catMaybes(Data_Functor.map(Data_Functor.functorArray)(pairChange)(cs));
                    };
                };
            };
        };
    };
};
var functorFilterChange = new Data_Functor.Functor(function (f) {
    return function (v) {
        return {
            rawChange: v.rawChange,
            event: f(v.event)
        };
    };
});
var queryAllLogs = function (dictDecodeEvent) {
    return function (dictIsSymbol) {
        return function (dictUnion) {
            return function (dictCons) {
                return new Heterogeneous_Folding.FoldingWithIndex(function (v) {
                    return function (v1) {
                        return function (acc) {
                            return function (filter) {
                                return Control_Bind.bind(Network_Ethereum_Web3_Types_Types.bindWeb3)(Data_Functor.map(Network_Ethereum_Web3_Types_Types.functorWeb3)(mkFilterChanges(dictDecodeEvent)()(dictIsSymbol)(v1)(Type_Proxy["Proxy"].value))(Network_Ethereum_Web3_Api.eth_getLogs(filter)))(function (v2) {
                                    return Data_Functor.map(Network_Ethereum_Web3_Types_Types.functorWeb3)(Data_Semigroup.append(Data_Semigroup.semigroupArray)(v2))(Data_Functor.map(Network_Ethereum_Web3_Types_Types.functorWeb3)(Data_Functor.map(Data_Functor.functorArray)(Data_Functor.map(functorFilterChange)(Data_Variant.expand())))(acc));
                                });
                            };
                        };
                    };
                });
            };
        };
    };
};
var foldMinToBlock = new Heterogeneous_Folding.FoldingWithIndex(function (v) {
    return function (v1) {
        return function (acc) {
            return function (f) {
                return Data_Ord.min(Network_Ethereum_Web3_Types_Types.ordChainCursor)(acc)(Data_Lens_Getter.viewOn(f)(Network_Ethereum_Web3_Types_Types["_toBlock"](Data_Lens_Internal_Forget.strongForget)));
            };
        };
    };
});
var foldMinFromBlock = new Heterogeneous_Folding.FoldingWithIndex(function (v) {
    return function (v1) {
        return function (acc) {
            return function (f) {
                return Data_Ord.min(Network_Ethereum_Web3_Types_Types.ordChainCursor)(acc)(Data_Lens_Getter.viewOn(f)(Network_Ethereum_Web3_Types_Types["_fromBlock"](Data_Lens_Internal_Forget.strongForget)));
            };
        };
    };
});
var filterProducer = function (dictRowToList) {
    return function (dictFoldlRecord) {
        return function (dictMapRecordWithIndex) {
            return function (v) {
                var succ = Data_Newtype.over()()(Network_Ethereum_Web3_Types_Types.BlockNumber)(function (v1) {
                    return Data_Semiring.add(Network_Ethereum_Core_BigNumber.semiringBigNumber)(v1)(Data_Semiring.one(Network_Ethereum_Core_BigNumber.semiringBigNumber));
                });
                var newTo = function (upper) {
                    return function (current) {
                        return function (window) {
                            return Data_Ord.min(Network_Ethereum_Web3_Types_Types.ordBlockNumber)(upper)(Data_Newtype.over()()(Network_Ethereum_Web3_Types_Types.BlockNumber)(function (v1) {
                                return Data_Semiring.add(Network_Ethereum_Core_BigNumber.semiringBigNumber)(v1)(Network_Ethereum_Core_BigNumber.embed(Network_Ethereum_Core_BigNumber["embedInt'"])(window));
                            })(current));
                        };
                    };
                };
                var waitForMoreBlocks = Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_Free_Trans.bindFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(Network_Ethereum_Web3_Types_Types.monadWeb3))(Control_Monad_Trans_Class.lift(Control_Monad_Free_Trans.monadTransFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple)))(Network_Ethereum_Web3_Types_Types.monadWeb3)(Effect_Aff_Class.liftAff(Network_Ethereum_Web3_Types_Types.monadAffWeb3)(Effect_Aff.delay(3000.0))))(function () {
                    return filterProducer()(dictFoldlRecord)(dictMapRecordWithIndex)(v);
                });
                var continueTo = function (maxEndBlock) {
                    var endBlock = newTo(maxEndBlock)(v.value0.currentBlock)(v.value0.windowSize);
                    var modify = function (fltr) {
                        return Data_Lens_Setter.set(Network_Ethereum_Web3_Types_Types["_toBlock"](Data_Profunctor_Strong.strongFn))(new Network_Ethereum_Web3_Types_Types.BN(endBlock))(Data_Lens_Setter.set(Network_Ethereum_Web3_Types_Types["_fromBlock"](Data_Profunctor_Strong.strongFn))(new Network_Ethereum_Web3_Types_Types.BN(v.value0.currentBlock))(fltr));
                    };
                    var fs$prime = Heterogeneous_Mapping.hmap(Heterogeneous_Mapping.hmapRecord()(dictMapRecordWithIndex))(new ModifyFilter(modify))(v.value0.filters);
                    return Control_Bind.discard(Control_Bind.discardUnit)(Control_Monad_Free_Trans.bindFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(Network_Ethereum_Web3_Types_Types.monadWeb3))(Control_Coroutine_Transducer.yieldT(Network_Ethereum_Web3_Types_Types.monadWeb3)(fs$prime))(function () {
                        return filterProducer()(dictFoldlRecord)(dictMapRecordWithIndex)(new MultiFilterStreamState({
                            currentBlock: succ(endBlock),
                            filters: v.value0.filters,
                            windowSize: v.value0.windowSize,
                            trailBy: v.value0.trailBy
                        }));
                    });
                };
                return Control_Bind.bind(Control_Monad_Free_Trans.bindFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(Network_Ethereum_Web3_Types_Types.monadWeb3))(Control_Monad_Trans_Class.lift(Control_Monad_Free_Trans.monadTransFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple)))(Network_Ethereum_Web3_Types_Types.monadWeb3)(Network_Ethereum_Web3_Api.eth_blockNumber))(function (chainHead) {
                    var $132 = Data_Ord.lessThan(Network_Ethereum_Web3_Types_Types.ordBlockNumber)(chainHead)(v.value0.currentBlock);
                    if ($132) {
                        return waitForMoreBlocks;
                    };
                    var v1 = Heterogeneous_Folding.hfoldlWithIndex(Heterogeneous_Folding.hfoldlRecordWithIndex()(dictFoldlRecord))(MultiFilterMinToBlock.value)(Network_Ethereum_Web3_Types_Types.Latest.value)(v.value0.filters);
                    if (v1 instanceof Network_Ethereum_Web3_Types_Types.Latest) {
                        return continueTo(Data_Newtype.over()()(Network_Ethereum_Web3_Types_Types.BlockNumber)(function (v2) {
                            return Data_Ring.sub(Network_Ethereum_Core_BigNumber.ringBigNumber)(v2)(Network_Ethereum_Core_BigNumber.embed(Network_Ethereum_Core_BigNumber["embedInt'"])(v.value0.trailBy));
                        })(chainHead));
                    };
                    if (v1 instanceof Network_Ethereum_Web3_Types_Types.BN) {
                        var targetEnd$prime = Data_Ord.min(Network_Ethereum_Web3_Types_Types.ordBlockNumber)(v1.value0)(Data_Newtype.over()()(Network_Ethereum_Web3_Types_Types.BlockNumber)(function (v2) {
                            return Data_Ring.sub(Network_Ethereum_Core_BigNumber.ringBigNumber)(v2)(Network_Ethereum_Core_BigNumber.embed(Network_Ethereum_Core_BigNumber["embedInt'"])(v.value0.trailBy));
                        })(chainHead));
                        var $134 = Data_Ord.lessThanOrEq(Network_Ethereum_Web3_Types_Types.ordBlockNumber)(v.value0.currentBlock)(targetEnd$prime);
                        if ($134) {
                            return continueTo(targetEnd$prime);
                        };
                        return Control_Applicative.pure(Control_Monad_Free_Trans.applicativeFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(Network_Ethereum_Web3_Types_Types.monadWeb3))(v);
                    };
                    throw new Error("Failed pattern match at Network.Ethereum.Web3.Contract.Events (line 208, column 8 - line 220, column 18): " + [ v1.constructor.name ]);
                });
            };
        };
    };
};
var filterChangeToIndex = function (v) {
    return new Data_Tuple.Tuple(v.rawChange.blockNumber, v.rawChange.logIndex);
};
var eventRunner = function (dictRowToList) {
    return function (dictMonad) {
        return function (dictVariantMatchCases) {
            return function (dictUnion) {
                return function (handlersR) {
                    return Control_Coroutine.consumer(dictMonad)(function (change) {
                        return Control_Bind.bind(dictMonad.Bind1())(processChange(dictMonad)()()()(handlersR)(change))(function (receipt) {
                            return Control_Applicative.pure(dictMonad.Applicative0())((function () {
                                if (receipt.action instanceof Network_Ethereum_Web3_Types_Types.ContinueEvent) {
                                    return Data_Maybe.Nothing.value;
                                };
                                if (receipt.action instanceof Network_Ethereum_Web3_Types_Types.TerminateEvent) {
                                    return new Data_Maybe.Just(receipt);
                                };
                                throw new Error("Failed pattern match at Network.Ethereum.Web3.Contract.Events (line 168, column 10 - line 170, column 37): " + [ receipt.action.constructor.name ]);
                            })());
                        });
                    });
                };
            };
        };
    };
};
var reduceEventStream = function (dictMonad) {
    return function (dictMonadRec) {
        return function (dictParallel) {
            return function (dictRowToList) {
                return function (dictVariantMatchCases) {
                    return function (dictUnion) {
                        return function (prod) {
                            return function (handlersR) {
                                return Control_Coroutine.pullFrom(dictMonadRec)(Data_Functor.map(Control_Monad_Free_Trans.functorFreeT(Control_Coroutine.functorAwait)(((dictMonad.Bind1()).Apply0()).Functor0()))(Data_Either.Right.create)(eventRunner()(dictMonad)()()(handlersR)))(Data_Functor.map(Control_Monad_Free_Trans.functorFreeT(Control_Coroutine.functorEmit)(((dictMonad.Bind1()).Apply0()).Functor0()))(Data_Either.Left.create)(Control_Coroutine_Transducer.toProducer(dictMonad)(prod)));
                            };
                        };
                    };
                };
            };
        };
    };
};
var eqFilterChange = new Data_Eq.Eq(function (f1) {
    return function (f2) {
        return Data_Eq.eq(Data_Tuple.eqTuple(Network_Ethereum_Web3_Types_Types.eqBlockNumber)(Network_Ethereum_Core_BigNumber.eqBigNumber))(filterChangeToIndex(f1))(filterChangeToIndex(f2));
    };
});
var ordFilterChange = new Data_Ord.Ord(function () {
    return eqFilterChange;
}, function (f1) {
    return function (f2) {
        return Data_Ord.compare(Data_Tuple.ordTuple(Network_Ethereum_Web3_Types_Types.ordBlockNumber)(Network_Ethereum_Core_BigNumber.ordBigNumber))(filterChangeToIndex(f1))(filterChangeToIndex(f2));
    };
});
var makeFilterChanges = function (dictRowToList) {
    return function (dictFoldlRecord) {
        return Control_Coroutine_Transducer.awaitForever(Network_Ethereum_Web3_Types_Types.monadWeb3)(function (fltrs) {
            return Control_Bind.bind(Control_Monad_Free_Trans.bindFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(Network_Ethereum_Web3_Types_Types.monadWeb3))(Control_Monad_Trans_Class.lift(Control_Monad_Free_Trans.monadTransFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple)))(Network_Ethereum_Web3_Types_Types.monadWeb3)(Heterogeneous_Folding.hfoldlWithIndex(Heterogeneous_Folding.hfoldlRecordWithIndex()(dictFoldlRecord))(QueryAllLogs.value)(Control_Applicative.pure(Network_Ethereum_Web3_Types_Types.applicativeWeb3)([  ]))(fltrs)))(function (changes) {
                return Control_Coroutine_Transducer.yieldT(Network_Ethereum_Web3_Types_Types.monadWeb3)(Data_Array.sort(ordFilterChange)(changes));
            });
        });
    };
};
var logsStream = function (dictRowToList) {
    return function (dictFoldlRecord) {
        return function (dictMapRecordWithIndex) {
            return function (dictFoldlRecord1) {
                return function (initialState) {
                    return Data_Functor.map(Control_Monad_Free_Trans.functorFreeT(Data_Functor_Coproduct.functorCoproduct(Data_Functor.functorFn)(Data_Tuple.functorTuple))(Network_Ethereum_Web3_Types_Types.functorWeb3))(Data_Tuple.fst)(Control_Coroutine_Transducer.fuse(Network_Ethereum_Web3_Types_Types.monadRecWeb3)(Network_Ethereum_Web3_Types_Types.monadParWeb3)(filterProducer()(dictFoldlRecord)(dictMapRecordWithIndex)(initialState))(stagger(Network_Ethereum_Web3_Types_Types.monadWeb3)(Network_Ethereum_Web3_Types_Types.monadRecWeb3)(Network_Ethereum_Web3_Types_Types.monadParWeb3)(makeFilterChanges()(dictFoldlRecord1))));
                };
            };
        };
    };
};
var event$prime = function (dictFoldlRecord) {
    return function (dictFoldlRecord1) {
        return function (dictRowToList) {
            return function (dictMapRecordWithIndex) {
                return function (dictRowToList1) {
                    return function (dictVariantMatchCases) {
                        return function (dictUnion) {
                            return function (dictFoldlRecord2) {
                                return function (filters) {
                                    return function (handlerR) {
                                        return function (v) {
                                            return Control_Bind.bind(Network_Ethereum_Web3_Types_Types.bindWeb3)((function () {
                                                var v1 = Heterogeneous_Folding.hfoldlWithIndex(Heterogeneous_Folding.hfoldlRecordWithIndex()(dictFoldlRecord))(MultiFilterMinFromBlock.value)(Network_Ethereum_Web3_Types_Types.Latest.value)(filters);
                                                if (v1 instanceof Network_Ethereum_Web3_Types_Types.BN) {
                                                    return Control_Applicative.pure(Network_Ethereum_Web3_Types_Types.applicativeWeb3)(v1.value0);
                                                };
                                                if (v1 instanceof Network_Ethereum_Web3_Types_Types.Latest) {
                                                    return Network_Ethereum_Web3_Api.eth_blockNumber;
                                                };
                                                throw new Error("Failed pattern match at Network.Ethereum.Web3.Contract.Events (line 114, column 19 - line 116, column 30): " + [ v1.constructor.name ]);
                                            })())(function (currentBlock) {
                                                var initialState = new MultiFilterStreamState({
                                                    currentBlock: currentBlock,
                                                    filters: filters,
                                                    windowSize: v.windowSize,
                                                    trailBy: v.trailBy
                                                });
                                                return Control_Coroutine.runProcess(Network_Ethereum_Web3_Types_Types.monadRecWeb3)(reduceEventStream(Network_Ethereum_Web3_Types_Types.monadWeb3)(Network_Ethereum_Web3_Types_Types.monadRecWeb3)(Network_Ethereum_Web3_Types_Types.monadParWeb3)()()()(logsStream()(dictFoldlRecord1)(dictMapRecordWithIndex)(dictFoldlRecord2)(initialState))(handlerR));
                                            });
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var pollFilter = function (dictRowToList) {
    return function (dictFoldlRecord) {
        return function (fids) {
            return function (stop) {
                return Control_Coroutine_Transducer.fromProducer(Network_Ethereum_Web3_Types_Types.monadWeb3)(Control_Coroutine.producer(Network_Ethereum_Web3_Types_Types.monadWeb3)(Control_Bind.bind(Network_Ethereum_Web3_Types_Types.bindWeb3)(Network_Ethereum_Web3_Api.eth_blockNumber)(function (bn) {
                    var $147 = Data_Ord.greaterThan(Network_Ethereum_Web3_Types_Types.ordChainCursor)(new Network_Ethereum_Web3_Types_Types.BN(bn))(stop);
                    if ($147) {
                        return Control_Applicative.pure(Network_Ethereum_Web3_Types_Types.applicativeWeb3)(Data_Either.Right.create(bn));
                    };
                    return Control_Bind.discard(Control_Bind.discardUnit)(Network_Ethereum_Web3_Types_Types.bindWeb3)(Effect_Aff_Class.liftAff(Network_Ethereum_Web3_Types_Types.monadAffWeb3)(Effect_Aff.delay(1000.0)))(function () {
                        return Control_Bind.bind(Network_Ethereum_Web3_Types_Types.bindWeb3)(Heterogeneous_Folding.hfoldlWithIndex(Heterogeneous_Folding.hfoldlRecordWithIndex()(dictFoldlRecord))(CheckMultiFilter.value)(Control_Applicative.pure(Network_Ethereum_Web3_Types_Types.applicativeWeb3)([  ]))(fids))(function (changes) {
                            return Control_Applicative.pure(Network_Ethereum_Web3_Types_Types.applicativeWeb3)(Data_Either.Left.create(Data_Array.sort(ordFilterChange)(changes)));
                        });
                    });
                })));
            };
        };
    };
};
var closeMultiFilterFold = function (dictIsSymbol) {
    return new Heterogeneous_Folding.FoldingWithIndex(function (v) {
        return function (v1) {
            return function (acc) {
                return function (filter) {
                    return Control_Bind.discard(Control_Bind.discardUnit)(Network_Ethereum_Web3_Types_Types.bindWeb3)(Data_Functor["void"](Network_Ethereum_Web3_Types_Types.functorWeb3)(Network_Ethereum_Web3_Api.eth_uninstallFilter(Data_Functor_Tagged.untagged(filter))))(function () {
                        return acc;
                    });
                };
            };
        };
    });
};
var checkMultiFilterLogs = function (dictDecodeEvent) {
    return function (dictIsSymbol) {
        return function (dictUnion) {
            return function (dictCons) {
                return new Heterogeneous_Folding.FoldingWithIndex(function (v) {
                    return function (v1) {
                        return function (acc) {
                            return function (filterId) {
                                return Control_Bind.bind(Network_Ethereum_Web3_Types_Types.bindWeb3)(Data_Functor.map(Network_Ethereum_Web3_Types_Types.functorWeb3)(mkFilterChanges(dictDecodeEvent)()(dictIsSymbol)(v1)(Type_Proxy["Proxy"].value))(Network_Ethereum_Web3_Api.eth_getFilterChanges(Data_Functor_Tagged.untagged(filterId))))(function (v2) {
                                    return Data_Functor.map(Network_Ethereum_Web3_Types_Types.functorWeb3)(Data_Semigroup.append(Data_Semigroup.semigroupArray)(v2))(Data_Functor.map(Network_Ethereum_Web3_Types_Types.functorWeb3)(Data_Functor.map(Data_Functor.functorArray)(Data_Functor.map(functorFilterChange)(Data_Variant.expand())))(acc));
                                });
                            };
                        };
                    };
                });
            };
        };
    };
};
var aquireFilter = function (dictRowToList) {
    return function (dictRowToList1) {
        return function (dictMapRecordWithIndex) {
            return function (dictFoldlRecord) {
                return function (dictFoldlRecord1) {
                    return function (dictFoldlRecord2) {
                        return function (dictFoldlRecord3) {
                            return function (dictFoldlRecord4) {
                                return function (fltrs) {
                                    return function (hs) {
                                        var stopPollingAt = Heterogeneous_Folding.hfoldlWithIndex(Heterogeneous_Folding.hfoldlRecordWithIndex()(dictFoldlRecord1))(MultiFilterMinToBlock.value)(Network_Ethereum_Web3_Types_Types.Latest.value)(fltrs);
                                        var withFilter = function (fids) {
                                            return hs(fids)(stopPollingAt);
                                        };
                                        var pollingFromBlock = Heterogeneous_Folding.hfoldlWithIndex(Heterogeneous_Folding.hfoldlRecordWithIndex()(dictFoldlRecord))(MultiFilterMinFromBlock.value)(Network_Ethereum_Web3_Types_Types.Latest.value)(fltrs);
                                        var onRelease = Data_Function["const"](Heterogeneous_Folding.hfoldlWithIndex(Heterogeneous_Folding.hfoldlRecordWithIndex()(dictFoldlRecord3))(CloseMultiFilter.value)(Control_Applicative.pure(Network_Ethereum_Web3_Types_Types.applicativeWeb3)(Data_Unit.unit)));
                                        var fltrs$prime = Heterogeneous_Mapping.hmap(Heterogeneous_Mapping.hmapRecord()(dictMapRecordWithIndex))(new ModifyFilter(function (v) {
                                            return Data_Lens_Setter.set(Network_Ethereum_Web3_Types_Types["_fromBlock"](Data_Profunctor_Strong.strongFn))(pollingFromBlock)(v);
                                        }))(fltrs);
                                        var aquire = openMultiFilter(dictFoldlRecord2)()(fltrs$prime);
                                        return Control_Monad_Fork_Class.bracket(Network_Ethereum_Web3_Types_Types.monadBracketWeb3)(aquire)(onRelease)(withFilter);
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
var pollEvent$prime = function (dictRowToList) {
    return function (dictRowToList1) {
        return function (dictRowToList2) {
            return function (dictMapRecordWithIndex) {
                return function (dictFoldlRecord) {
                    return function (dictFoldlRecord1) {
                        return function (dictVariantMatchCases) {
                            return function (dictFoldlRecord2) {
                                return function (dictFoldlRecord3) {
                                    return function (dictFoldlRecord4) {
                                        return function (dictUnion) {
                                            return function (filters) {
                                                return function (handlers) {
                                                    var processor = function (fids) {
                                                        return function (stop) {
                                                            return Control_Coroutine.runProcess(Network_Ethereum_Web3_Types_Types.monadRecWeb3)(reduceEventStream(Network_Ethereum_Web3_Types_Types.monadWeb3)(Network_Ethereum_Web3_Types_Types.monadRecWeb3)(Network_Ethereum_Web3_Types_Types.monadParWeb3)()()()(stagger(Network_Ethereum_Web3_Types_Types.monadWeb3)(Network_Ethereum_Web3_Types_Types.monadRecWeb3)(Network_Ethereum_Web3_Types_Types.monadParWeb3)(pollFilter()(dictFoldlRecord4)(fids)(stop)))(handlers));
                                                        };
                                                    };
                                                    return aquireFilter()()(dictMapRecordWithIndex)(dictFoldlRecord)(dictFoldlRecord1)(dictFoldlRecord2)(dictFoldlRecord3)(dictFoldlRecord4)(filters)(processor);
                                                };
                                            };
                                        };
                                    };
                                };
                            };
                        };
                    };
                };
            };
        };
    };
};
module.exports = {
    "event'": event$prime,
    "pollEvent'": pollEvent$prime,
    reduceEventStream: reduceEventStream,
    aquireFilter: aquireFilter,
    pollFilter: pollFilter,
    logsStream: logsStream,
    FilterChange: FilterChange,
    MultiFilterStreamState: MultiFilterStreamState,
    eqFilterChange: eqFilterChange,
    ordFilterChange: ordFilterChange,
    functorFilterChange: functorFilterChange,
    foldMinToBlock: foldMinToBlock,
    foldMinFromBlock: foldMinFromBlock,
    modifyFilter: modifyFilter,
    queryAllLogs: queryAllLogs,
    openMultiFilterFold: openMultiFilterFold,
    checkMultiFilterLogs: checkMultiFilterLogs,
    closeMultiFilterFold: closeMultiFilterFold
};
